"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class StorageAPI {
    constructor(storage, storageKey) {
        this.storage = storage;
        this.storageKey = storageKey;
    }
    getState() {
        const auth = JSON.parse(this.storage.getItem(this.storageKey) || '{}');
        return auth || {};
    }
    setState(newState) {
        const currentState = this.getState();
        const mergedState = Object.assign({}, currentState, newState);
        this.storage.setItem(this.storageKey, JSON.stringify(mergedState));
    }
    purgeState() {
        this.storage.removeItem(this.storageKey);
    }
}
exports.StorageAPI = StorageAPI;
//# sourceMappingURL=StorageAPI.js.map